import { Typography } from 'antd'
import styled from 'styled-components'

const { Title } = Typography

export const StyledTitle = styled(Title)`
  color: #25855a !important;
  margin-bottom: 0 !important;
`
